// extracted by mini-css-extract-plugin
module.exports = {"signupWidget":"SignupWidget_signupWidget__cSEQX","button":"SignupWidget_button__1KcDp"};